import axios from 'axios';
import { toast } from 'react-toastify';
import {CONFIG} from '../utility/config'

const API = axios.create({ baseURL: CONFIG.SERVER_URL });
API.interceptors.request.use((req) => {
    if (localStorage.getItem('token')) {
        const token = JSON.parse(localStorage.getItem('token')) || '';
        req.headers.Authorization = `Bearer ${token}`;
    }

    return req;
});

API.interceptors.response.use(null, error => {
    const expectedError =
     error.response &&
     error.response.status >= 400 &&
     error.response.status < 500;

    if (!expectedError) {
     toast.error("An unexpected error occurred");
    }
   
    return Promise.reject(error);
});

// API.interceptors.response.use(response => {
//     return response;
//  }, error => {
//     //    if (error.response.status === 401) {
//     //        //return error.response;
//     //       //  window.location.assign('/login');
//     //    }
//     console.log(error)
// //    if(error.response.status === 500) {
// //        alert("Server error");
// //    }
//   // return error;
   
//  });

// authantication apis
export const signIn = (formData) => API.post('/api/login', formData);
export const signUp = (formData) => API.post('/api/signup', formData);
export const logOut = () => API.get('/api/logout');
export const changePassword = (updatedForm) => API.put('/api/password/update', updatedForm);
export const passwordReset = ({ password, type, id }) => API.put(`api/reset/password?id=${id}&type=${type}`, { password });
export const resendEmailVerification = (email) => API.post(`api/resend/verification/${email}`);
export const emailVerify = ({id ,type}) => API.put(`/api/user/verify/?id=${id}&type=${type}`);
export const getEmailByUser = (email) => API.post(`/api/forgetPassword/${email}`);
export const refreshExpireToken = () => API.get(`api/refresh-token`);
export const verifyRecaptcha = (captchaData) => API.post('api/verify/recaptcha', captchaData)
// current user
export const getUserProfile = () => API.get('/api/user/profile');
//export const loadCurrentUser = () => API.get('/api/user/profile');
export const getUser = (id) => API.get(`/api/user/get/${id}`);
export const updateProfile = (updateForm) => API.put('/api/update/profile', updateForm);

// client apis
export const getAllClient = () => API.get('/api/admin/users/list');
export const storeClient = (formData) => API.post('/api/admin/user/create', formData);
export const editClient = (id) => API.get(`/api/admin/user/profile/${id}`);
export const updateClient = (userData) => API.put('/api/admin/user/update', userData);
export const deleteClient = (id) => API.delete(`/api/admin/user/delete/${id}`);

// subadmins apis
export const getAllSubadmin = () => API.get('/api/admin/users/list/?type=subadmin');
export const storeSubadmin = (formData) => API.post('/api/admin/user/create', formData);
export const editSubadmin = (id) => API.get(`/api/admin/user/profile/${id}`);
export const updateSubadmin = (userData) => API.put('/api/admin/user/update', userData);
export const deleteSubadmin = (id) => API.delete(`/api/admin/user/delete/${id}`);

// roles apis
export const getRole = () => API.get('/api/admin/user-type/list');

// admin projects
export const getDashboardProject = () => API.get('/api/admin/project-list');
// make payment for partner
export const makePaymentPartner = (formData) => API.post('/api/payment/make-payment', formData);

// subscriptions apis
export const getAllSubscription = () => API.get('/api/subscription-list');
export const storeSubscription = (formData) => API.post('/api/admin/subscription-add', formData);
export const editSubscription = (id) => API.get(`/api/admin/subscription-plans/details/${id}`);
export const updateSubscription = (userData) => API.put(`/api/admin/subscription-update`, userData);
export const updateSubscriptionStatus = (userData) => API.post('/api/admin/subscription-plans/change-status', userData);
export const deleteSubscription = (id) => API.delete(`/api/admin/subscription-plans/delete/${id}`);

// email templates api
export const getAllEmailTemplates = () => API.get('/api/admin/email-templates/list');
export const createAndUpdateEmailTemplate = (templateDetail) => API.post('/api/admin/update/template', templateDetail);
export const getEmailTemplateByType = (type) => API.get(`/api/admin/email-template?type=${type}`);
export const deleteEmailTemplate = (id) => API.get(`/api/admin/email-templates/remove/${id}`);
export const updateEmailTemplateStatus = (data) => API.put(`/api/admin/email-templates/change-status`, data);
// payment history api
export const getPaymentHistory = () => API.get('/api/admin/payment/list');

// user dashboard apis
export const getUserDashboardList = () => API.get('/api/dashboard');
export const updateProjectShortCut = (projectData) => API.put('/api/projects/add-to-shortcuts', projectData);
// admin dashboard api
export const getDashboardStats = () => API.get('/api/admin/dashboard/stats');

// projects apis
export const getProjectsList = (searchInput,partner, search_date, status) => API.get(`/api/projects/my-projects?search_text=${searchInput}&search_date=${search_date}&search_status=${status}&search_partner=${partner}`);
export const getProjectsListForAddPartner = () => API.get(`/api/projects/my-projects`);
export const createProjectDetail = (projectDetail) => API.post('/api/project/create', projectDetail);
export const getCampaignList = (id) => API.get(`/api/campaigns/list?id=${id}`);
export const getObjectiveType = () => API.get('/api/master-data/objective-types');
export const getAudienceType = () => API.get('/api/master-data/audience-types');
export const editProject = (id) => API.get(`/api/project/${id}`);
export const getProjectsMembers = (id) => API.get(`/api/project/members/${id}`);
export const updateProject = (formData) => API.put(`/api/project/update`, formData);
export const updateBackgroundProject = (formData) => API.put(`/api/update/background`, formData);
export const getProjectApproverList = (id) => API.get(`/api/project/approver-list/${id}`);

export const updateRelatedCampaignsProject = (formData) => API.post(`/api/projects/update-project`, formData);
export const resendInviteEmailMember = (id) => API.put(`/api/resend-invitation/${id}`);
export const getProjectsSupportingDocumentsList = (project, searchInput) => API.get(`/api/projects/supporting-doc/${project}?q=${searchInput}`);
export const getProjectTimelines = (projectId) => API.get(`/api/project/timeline-planning/${projectId}`);

// partner create 
export const getAllPartner = () => API.get('/api/projects/my-partners');
export const getAllPartnerOption = () => API.get('/api/partner-list');
export const storePartner = (formData) => API.post('/api/project/accept-invitation', formData);
export const deletePartner = (formData) => API.post('/api/projects/remove-partner', formData);
export const getProjectsStatus = () => API.get('/api/master-data/project-status-list');
export const addNewParnter = (partners) => API.post('/api/projects/add-partner', partners);
export const getProjectScheduleDetail = (id) => API.get(`/api/project/schedule-detail/${id}`)
export const checkInvitationEmail = (email, projectId) => API.get(`/api/invited-user/check/${email}/${projectId}`)
export const acceptInvitationProject = (formData) => API.put('api/invited-user/accepted',formData)

export const getObjectiveList = () => API.get('/api/admin/objective/list');
export const createObjective = (formData) => API.post('/api/admin/objective/create', formData);
export const updateObjective = (formData) => API.post(`/api/admin/objective/update/${formData.id}`, formData);
export const deleteObjective = (id) => API.delete(`/api/admin/objective/delete/${id}`);
export const updateObjectiveStatus = (formData) => API.post(`/api/admin/objective/update/${formData.id}`, formData);


export const getAudienceList = () => API.get('/api/admin/audience/list');
export const createAudience = (formData) => API.post('/api/admin/audience/create', formData);
export const updateAudience = (formData) => API.post(`/api/admin/audience/update/${formData.id}`, formData);
export const deleteAudience = (id) => API.delete(`/api/admin/audience/delete/${id}`);
export const updateAudienceStatus = (formData) => API.post(`/api/admin/audience/update/${formData.id}`, formData);

// home page contend
export const getHompageContent = () => API.get('/home/content');
export const createPageContent = (content) => API.post('/api/admin/manage/content', content);

// subscriprion list form frontend
export const indexSubscriptions = () => API.get('/api/subscription-list');

// members apis
export const getAllMembers = () => API.get('/api/members-list');
export const storeMembers = (formData) => API.post('/api/create-member', formData);
export const editMembers = (id) => API.get(`/api/admin/user/profile/${id}`);
export const updateMembers = (userData) => API.put(`/api/member-edit/${userData.id}`, userData);
export const deleteMembers = (id) => API.delete(`/api/member-delete/${id}`);

// project job number unique
export const apiCurrentPartner = (email) => API.get(`/api/search/users?q=${email}   `);
export const apiCheckJobNumber = (jobNumber) => API.get(`api/check/job-number/${jobNumber}`);

// project background
export const rejectBackground = (formData) => API.put(`/api/background-text/rejected/${formData.project_id}`, formData);
export const editBackground = (id) => API.get(`/api/background-detail/${id}`);
export const updateBackgroundOwnersApprovers = (userData) => API.post('/api/create-background', userData);
export const updateBackgroundApprove = (id) => API.put(`/api/background-text/approve/${id}`);
export const updateBackgroundByOwner = (formData) => API.put('/api/background-text/add', formData);
export const requestBackgroundEdit = (id) => API.put(`/api/background/reset/request/${id}`);
export const acceptBackgroundUpdateRequestByUser = (formData) => API.put(`/api/background/update/reset-request/${formData.token}`, formData);

// project objective
export const editObjectives = (id) => API.get(`/api/objective-detail/${id}`);
export const updateOwnerObjectives = (formData) => API.put('/api/objective-metrics/add', formData);
export const updateObjectives = (userData) => API.post('/api/create-objective', userData);
export const updateObjectivesApprove = (id) => API.put(`/api/objective-metrics/approve/${id}`);
export const rejectObjectives = (formData) => API.put(`/api/objective-metrics/rejected/${formData.project_id}`, formData);
export const requestObjectivesEdit = (id) => API.put(`/api/objective/reset/request/${id}`);
export const requestAcceptObjectievEdit = (formData) => API.put(`/api/objective/update/reset-request/${formData.token}`, formData);

// project audience
export const editAudience = (id) => API.get(`/api/audience-detail/${id}`);
export const updateAudienceByOwner = (formData) => API.put('/api/audience-insights/add', formData);
export const updateProjectAudience = (userData) => API.post('/api/create-audience', userData);
export const updateAudienceApprove = (formData) => API.put(`/api/audience-insights/approve/${formData.project_id}?id=${formData.id}`);
export const rejectAudience = (formData) => API.put(`/api/audience-insights/rejected/${formData.project_id}?id=${formData.id}`, formData);
export const requestAudienceEdit = (formData) => API.put(`/api/audience/reset/request/${formData.project_id}?id=${formData.id}`);
export const acceptAudienceUpdateRequestByUser = (formData) => API.put(`/api/audience/update/reset-request/${formData.token}`, formData);

// project timelines
export const loadProjectTimeline = (id) => API.get(`/api/timeline/strategiest-list/${id}`);
export const createTimelineProjectStrategist = (formData) => API.post('/api/create-timeline', formData);
export const createTimelineProject = (formData) => API.post('/api/strategist/add/owner-approver', formData);
export const updateTimelineProject = (formData) => API.post('/api/strategist/add/owner-approver', formData);
export const destroyProjectTimelineStrategist = (formData) => API.post('/api/delete/strategist', formData);
export const destroyProjectTimelineStage = (formData) => API.post('/api/delete/timeline-stage', formData);
// export const updateProjectTimeline = (userData) => API.post('/api/timeline/resend/invitation', userData);
export const updateProjectTimelineByOwner = (formData) => API.put('/api/timeline/owner-update', formData);
export const updateProjectTimelineByApprover = (formData) => API.put('/api/timeline/approver-approve', formData);
export const rejectProjectTimeline = (formData) => API.put('/api/timeline/approver-reject', formData);
export const requestProjectTimelineEdit = (formData) => API.put('/api/timeline/send/reset-request', formData);
export const acceptProjectTimelineUpdateRequestByUser = (formData) => API.put('/api/timeline/update/request', formData);
export const apiAcceptProjectTimelineInvitationByMember = (formData) => API.put('/api/timeline/invitation', formData);
export const apiResendInvitationStrategistByUser = (formData) => API.put('/api/timeline/resend/invitation', formData);

export const allTimelineStagesAPI = (id) => API.get(`/api/timeline/stage-list/${id}`);
export const uploadeTimelineDocumentsAPI = (formData) => API.post('/api/timeline/upload-document', formData);
export const updateDocumentNameTimelineAPIByOwner = (formData) => API.put('/api/timeline/update/document-name', formData);
export const changeTimelineStageStatusByApprover = (formData) => API.put('/api/stage/document/approve-reject', formData);
export const deleteTimelineStageDocument = (formData) => API.post('/api/delete/stage-document', formData);
export const changeTimelineStageCompeleteByOwner = (formData) => API.post('/api/timeline/complete', formData);
export const rejectApproveStageCompeleteByApprover = (formData) => API.put('/api/stage/complete/approve-reject', formData);

// project supporting documnets
export const editDocument = (id) => API.get(`/api/supporting_doc/detail/${id}`);
export const updateSupportingDocsProject = (formData) => API.post(`/api/supporting-doc/create`, formData);
export const updateDocumentByOwner = (formData) => API.post('/api/supporting_doc/owner/update', formData);
export const updateFileNameAPIByOwner = (formData) => API.put(`/api/supporting_doc/owner/update/${formData.id}`, formData);
export const updateDocumentApprove = (id) => API.put(`/api/supporting_doc/approver/approve/${id}`);
export const rejectDocuments = (formData) => API.put(`/api/supporting_doc/approver/reject/${formData.id}`, formData);
export const deleteSupportingDocs = (id) => API.delete(`/api/supporting_doc/delete/${id}`);
export const requestDocumentEdit = (id) => API.put(`/api/supporting_doc/reset/request/${id}`);

export const acceptDocumentUpdateRequestByUser = (formData) => API.put('/api/supporting_doc/update/request', formData);


// project job number unique
export const getChatUser = (id) => API.get(`/api/message/member-list/${id}`);
export const getChat = (projectId, id) => API.get(`/api/messages/list/${projectId}?id=${id}`);
export const sendMessage = (formData) => API.post('/api/message/send', formData);
